<template>
  <div>
    <div>
      <p v-if="!d">⚠ No data in InfoCardSoc</p>
      <p v-if="d && !d.coordinator">⚠ No coordinator in InfoCardSoc</p>
      <p v-if="d && d.coordinator && !d.coordinator.name">⚠ Імʼя координатора не вказано</p>
    </div>

    <div class="info-card" ref="cards">
      <div class="p w-100">
        <div class="title">Адреса</div>
        <div class="value">
          {{ d.address || d.full_data?.address || "⚠ Не вказано адресу" }}
        </div>
      </div>

      <div class="p-container">
        <div class="p">
          <GoogleMapButton :d="d"/>
        </div>

        <div class="p-coordinator">
          <div class="title">Координатор</div>
          <div class="value">
            {{
              publicCoordinatorName(d.coordinator?.name || d.full_data?.coordinator?.name)
              || "⚠ Імʼя координатора не вказано"
            }}
          </div>
          <div class="title">Телефон</div>
          <div class="value">
            {{ d.coordinator?.phone_number || d.full_data?.coordinator?.phone_number || "⚠ Номер телефону не зазначено" }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import GoogleMapButton from './GoogleMapButton.vue';

export default {
  props: ["d"],

  components: {
    GoogleMapButton,
  },

  computed: {
    //   address() {
    //     return [
    //         this.d.region, this.d.city, this.d.street, this.d.building_num
    //     ].join(", ")
    //   },
  },

  mounted() {
  },

  methods: {
    bool2human(val) {
      return val ? "так" : "ні"
    },
    coordinatorGivenName(full) {
      if (!full) return "";
      const parts = full.trim().split(/\s+/);
      return parts[1] || ""; // second token is the given name
    },
    publicCoordinatorName(full) {
      const name = (full || "").trim();
      if (!name) return "";
      // Always show only the given name (2nd token). Surname is first by your data contract.
      const parts = name.split(/\s+/);
      return parts[1] || parts[0] || "";
    }
  }
}
</script>

<style lang="scss" scoped>
.info-card {
  color: var(--col-mainblue);
  padding: 0.1em;
  font-size: 1rem;
  gap: 1em;
  overflow: hidden;

  h3 {
    margin-bottom: 1em;
  }

  p {
    margin-bottom: 1em;
  }

  hr {
    border: 1px solid white;
  }

  display: flex;
  flex-wrap: wrap;

  .p {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-width: 30%;
    min-width: 13em;

    .title {
      /*font-size: 0.7rem;*/
      font-style: normal;
    }

    .value {
      font-style: normal;
    }

  }

  .value {
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .supertitle {
    font-size: 1.3rem;
  }

  .p.w-100 {
    min-width: 100%;
    margin-bottom: 0.5rem;
  }

  .p-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    gap: 1em;
  }

  .p-coordinator, .p-phone_number {
    flex: 2;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

}
</style>
